import { Icon, IconProps } from "../";

export const StarsIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M51.99,1482 C46.47,1482 42,1486.48 42,1492 C42,1497.52 46.47,1502 51.99,1502 C57.52,1502 62,1497.52 62,1492 C62,1486.48 57.52,1482 51.99,1482 Z M55.22,1497.39 L52,1495.45 L48.78,1497.39 C48.4,1497.62 47.93,1497.28 48.03,1496.85 L48.88,1493.19 L46.05,1490.74 C45.72,1490.45 45.9,1489.9 46.34,1489.86 L50.08,1489.54 L51.54,1486.09 C51.71,1485.68 52.29,1485.68 52.46,1486.09 L53.92,1489.53 L57.66,1489.85 C58.1,1489.89 58.28,1490.44 57.94,1490.73 L55.11,1493.18 L55.96,1496.85 C56.06,1497.28 55.6,1497.62 55.22,1497.39 L55.22,1497.39 Z"
        transform="translate(-40 -1480)"
      />
    </Icon>
  );
};
